import { render, staticRenderFns } from "./ProjectDashboard.vue?vue&type=template&id=48434c66&"
import script from "./ProjectDashboard.vue?vue&type=script&lang=js&"
export * from "./ProjectDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports